<script lang="tsx">
  import { Transition } from "vue";
  import { Skeleton } from "primevue";
  import Sidebar from "./Sidebar.vue";

  export default {
    components: { Skeleton, Transition, Sidebar },
    props: Sidebar.props as (typeof Sidebar["props"]),
  };
</script>

<template>
  <Suspense v-bind.attr="$attrs">
    <Transition appear name="fadeslide" style="--animation-duration: 0.5s;">
      <Sidebar v-bind.attr="$attrs" v-bind.prop="$props as any"/>
    </Transition>

    <template #fallback>
      <Skeleton width="100%" height="100%"/>
    </template>
  </Suspense>
</template>

<style lang="less">
  .fadeslide-enter-active {
    animation: fade-in var(--animation-duration), slide-inline-end-in var(--animation-duration);
  }

  .fadeslide-leave-active {
    animation: fade-in var(--animation-duration) reverse, slide-inline-end-in var(--animation-duration);
  }
</style>
